import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
import Select from "react-select";
import Editpop from '../Screen/OatEditpop';
import _ from 'lodash'
const pageSize = 5;
const Oatassignmain = () => {

  
  // Display OAT users

  const token = JSON.parse(localStorage.getItem('usertoken'));
  const [allusers, setAllusers] = useState([])
  const [allAssignusers, setAssignAllusers] = useState([])
  const [paginatedPosts, setpaginatedPosts] = useState();
  const [currentPage, setcurrentPage] = useState(1);


  useEffect(()=>{
    getAssignUsers()
    getUsers()
  }, [])
  function getAssignUsers(){


    console.log("Token", token)
  fetch(`${BASE_URL}/oat/GetOatAssign`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("Data", data)
      setAssignAllusers(data)
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        }
    );

console.log("check",allusers)
  }

  const pageCount = allAssignusers? Math.ceil(allAssignusers.length/pageSize) :0;
  // if (pageCount === 1)
  // return null;
  
  const pages = _.range(1, pageCount+1)
  
  const pagination =(pageNo)=>{
  setcurrentPage(pageNo);
  const startIndex = (pageNo - 1) * pageSize;
  const paginatedPost = _(allAssignusers).slice(startIndex).take(pageSize).value();
  setpaginatedPosts(paginatedPost)
  }
  const onNext = () => {


    pagination(currentPage + 1);
  };

  const onPrevious = () => {
    pagination(currentPage - 1);
  };



  function getUsers(){

    console.log("Token", token)
    fetch(`${BASE_URL}/Oat/Getoatusers`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
        console.log("Data", data)
        setAllusers(data)
          }
      );
  
  console.log("check",allusers)
  }

  // AssignSection







     // AssignSection

  const [selectedOptions, setSelectedOptions] = useState();

 
  const optionList = [
    { value: "Home", label: "Home" },
    { value: "Entities", label: "Entities" },
    { value: "Categories", label: "Categories" },
    { value: "Announcement", label: "Announcement" },
   
  ];

  function handleSelect(data) {
    setSelectedOptions(data);
  }







  function AssignSection(){

       var id = document.getElementById('oatuserid').value;
     
      //  var section = document.getElementById('section').value

      // let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

      // console.log(section);

      let assign = selectedOptions.map((item) => item.label);
      console.log(assign)
     
      let section = assign.toString();
      
      const body ={
        id:id,  
        section:section,
        assignStatus:0
      }
      axios({

        method:"POST",
        url:`${BASE_URL}/Oat/AssignSection`,
        data:body,
        headers: {
          "Content-Type" : "application/json",

          "Authorization": "Bearer " + `${token}`
        }

    })
    .then((response) =>{
      console.log(response.data);
    
      if(response.data.message="Section Added!"){
      // toast.success("Task Assigned Successfully !", {
      //   position: "top-center",
      //   autoClose: 3200,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   className: 'toast-message'
      //   });
      //alert("Task Assigned Successfully !")
      document.getElementById("assignform").reset()
      document.getElementById("AssignSuccess-Oat").style.display="block"
          setSelectedOptions("")
          getAssignUsers()
        setTimeout(() => {
          document.getElementById("AssignSuccess-Oat").style.display="none"
       
        }, 3000);
       
      }
     })
     .catch(error => {
     console.log(error);
    alert("failed !")
 
      })
      }
  //SelectParticular

  const [Editoat, setEditoat] =useState([])

  function SelectParticular(Id){

    const body =
      {
        
       id:Id
      }
      console.log('body',body);

    
      axios({
             method:"POST",
             url :`${BASE_URL}/Tec/Getparticularid`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer " + `${token}`,
              }     
          }) 
          
     
          .then((response) =>{
            console.log(response.data);
       
         
            setEditoat(response.data)
                  
            localStorage.setItem("EditData",JSON.stringify(response.data))
            
         })
         .catch(error => {
           console.log(error);
           
         })
   }



   function DeleteStatus(Id,UserName){

    //confirm delete

 
     const body ={
      id: Id
    }
     console.log(body)
      axios({
     
      method:"POST",
     url:`${BASE_URL}/oat/AssignStatus`,
     data:body,
     headers: {
     "Content-Type" : "application/json",

     "Authorization": "Bearer " + `${token}`,
  
     }
    
      })
      .then((response) =>{
      console.log(response.data);

      closeForm();
   
      // toast.info(  "Deleted"+" " + UserName +  "!", {
      //  position: "top-center",
      //  autoClose: 3200,
      //  hideProgressBar: false,
      //  closeOnClick: true,
      //  pauseOnHover: true,
      //  draggable: true,
      //  progress: undefined,
      //  className: 'toast-message'
      //  });

      //alert("Deleted Successfully")
      document.getElementById("DelSuccess-Oat").style.display="block"
      getAssignUsers()
       setTimeout(() => {
        setcurrentPage(1)
        document.getElementById("DelSuccess-Oat").style.display="none"
       
       }, 3000);
     
     
      })
   
         
  
     }

 function closeForm(){
  document.getElementById("modaldeleteForm").style.display ="None"

 }

//  ConfirmDelete 


function ConfirmDelete(Id,UserName)
{
  SelectParticular(Id,UserName)

  setTimeout(() => {
    document.getElementById("modaldeleteForm").style.display = "block";
  },1000);
 
 }  

  return (
  
    <>
    <div className='oat-addmain'>
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
       
    <div className="oat-addgrid-layout">
    <div className="oat-addmain-top">
        <div className='oat-addmain-back'>
          
        </div> 
          
           <span className='OatTitle'>
    <span>ASSIGN</span></span>
    <div className='oat-addmain-back'>
      <Link to="/OAT"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
     </div>
 </div>

   {/* Alert Messages */}
   {/* Assign success */}
    
   <div className='oat-toastpop-fade' id="AssignSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Assigned successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>
 {/* Delete success */}
    
 <div className='oat-toastpop-fade' id="DelSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Deleted successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>
 

    <div className='oat-AssignMain-table'>
    <div class="oatAssignMain-table-responsive">
    <form id="assignform">
      
     <table class="AssignMain-Table-oat">
      <thead>
      <tr>
     {/* <th></th> */}
      <th>USERNAME</th>
      <th>ASSIGN</th>
      <th>ACTION</th>
      </tr>
  </thead>
  <tbody>
<tr>
      
      {/* <td id="checkbox"><input type='checkbox'/></td> */}
      <td><select className='oat-Assign-select' id='oatuserid'>
        
      {allusers.map((e) => {
      return<option id="username" value={e.id}>{e.userName}</option>})}
        </select>
        </td>
        <td id="ScrollAssignOat" style={{whiteSpace:"nowrap",width:"300px"}}>
              
        <div id="OatAssignSelect"><Select  
       
       className="dropdown"
   options={optionList}
   id="OatAselect"
   placeholder="Select Section"
   value={selectedOptions}
   onChange={handleSelect}
   isSearchable={true}
   isMulti
   isClearable
 /></div>


        </td>
      <td className='text-center'>
     
<button className='oat-Assign-button' type='submit' onClick={AssignSection}> ASSIGN </button>
</td>
 
    </tr>
    
   

  </tbody>
</table>
</form>  
</div>
</div>

{/* // section display table */}

{/* <div className='oat-AssignMain-table'>
<div class="oatAssignMain-table-responsive"> */}
 {/* <table class="AssignMain-Table-oat"> */}

 {
  allAssignusers.length==0  ? (<div id="OatApiFail">" Not Yet Assigned "</div>):(<div>
 <div className='oattable'>

  <div class="oat-table_responsive">

 <table> 
  <thead>
    <tr>
     
      <th>USERNAME</th>
      <th>SECTION</th>
      <th>ACTION</th>
      </tr>
  </thead>
  <tbody>

  {paginatedPosts.map((e) => {
      return<tr>
      
      <td>{e.userName}</td>
      <td >
     {e.section}
     </td>
     <td>
      <span class="oatAssign-action_btn">
      <span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id,e.UserName)} id="OatDelicon"></i></span>
            </span>
      </td>
      
      
    </tr>

})}
    
  </tbody>
</table>

</div>
</div>
<br></br>
{pageCount==1?null:<nav id="oatpagenav" style={{marginTop:"30px"}}>
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
        {currentPage >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="oatpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
  </div>)} 
{/* DeletePopup */}

{Editoat.map((e)=>{ 
   return<div className="oat-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="oat-adduser-button" onClick={()=>DeleteStatus(e.id,e.userName)} type='submit'>Delete</button>
        <button className="oat-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
</div>

 </>
 
  )
}

export default Oatassignmain
